import { isBrowser } from "../browser-utils";

declare global {
	interface Window {
		dataLayer?: unknown[];
	}
}

export function pushEvent(dataLayerChange: unknown): void {
	if (isBrowser()) {
		if (!window.dataLayer) window.dataLayer = [];
		window.dataLayer.push(dataLayerChange);
	}
}
